
import axios from 'axios'

const baseURL =
  process.env.NODE_ENV === 'development'
    ? 'http://localhost:3000'
    : '/api'; 

const Axios = axios.create({
  baseURL,
  withCredentials: true
});

export default Axios